import type { JobData } from "~/types/job";

export interface SavedJobsResponse {
	data: JobData[];
	current_page: number;
	last_page: number;
}

export class SavedJobsRepository {
	private baseUrl = globalConfig.API + "/profile/saved-jobs";
	private savedJobIdsUrl = globalConfig.API + "/profile/saved-job-ids";

	async getSavedJobs(page = 1, perPage = 15): Promise<SavedJobsResponse> {
		const token = useAuth.getToken();
		const url = new URL(this.baseUrl);
		url.searchParams.append("page", String(page));
		url.searchParams.append("per_page", String(perPage));

		try {
			return await $fetch<SavedJobsResponse>(url.href, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (err) {
			showError({ statusCode: 500, message: "SavedJobsRepository.getSavedJobs error" });
			throw err;
		}
	}

	async getSavedJobIds(): Promise<number[]> {
		const token = useAuth.getToken();

		try {
			return await $fetch<number[]>(this.savedJobIdsUrl, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (err) {
			console.error("SavedJobsRepository.getSavedJobIds error");
			return [];
		}
	}
}
